<div class="empty-state" role="status">
  <span aria-hidden="true" class="empty-state__icon material-symbols-outlined">
    {{ icon() }}
  </span>
  <p class="empty-state__title">{{ title() | transloco: params() }}</p>
  @if (description()) {
    <p class="empty-state__description">
      {{ description() | transloco: params() }}
    </p>
  }
</div>
